<ion-content [fullscreen]="true" class="auth-page">
  <!-- Layout: koomzodesignsystem features/auth/pages/login (specs/auth.md §5.2). The shell owns
       the frame and the 1000px split; this template only fills its slots. -->
  <app-kz-auth-shell>
    <app-kz-brand-lockup
      appbar
      [strapline]="'app.pages.auth.login.brand.strapline' | translate"
    ></app-kz-brand-lockup>
    <app-kz-language-bar
      appbar
      variant="pill"
      [languages]="languages"
      [activeLang]="(lang$ | async) ?? 'en'"
      [ariaLabel]="'app.pages.auth.login.aria.language' | translate"
      (langChange)="onLanguageChange($event)"
    ></app-kz-language-bar>

    <!-- The same lockup and language control again, on primary. Only one pair is on screen. -->
    <app-kz-brand-lockup
      pitchTop
      [onPrimary]="true"
      [strapline]="'app.pages.auth.login.brand.strapline' | translate"
    ></app-kz-brand-lockup>
    <app-kz-language-bar
      pitchTop
      variant="pill"
      [onPrimary]="true"
      [languages]="languages"
      [activeLang]="(lang$ | async) ?? 'en'"
      [ariaLabel]="'app.pages.auth.login.aria.language' | translate"
      (langChange)="onLanguageChange($event)"
    ></app-kz-language-bar>

    <div pitchLead>
      <h2 class="pitch__h">{{ 'app.pages.auth.login.pitch.headline' | translate }}</h2>
      <p class="pitch__p">{{ 'app.pages.auth.login.pitch.body' | translate }}</p>
    </div>
    <div pitchPills class="pitch__pills">
      <app-auth-pitch-pill icon="swap-horizontal-outline">
        {{ 'app.pages.auth.login.pitch.pill.devices' | translate }}
      </app-auth-pitch-pill>
    </div>
    <!-- The walkthrough opens only from Login and Signup (kz2 F1); every exit lands on Signup. -->
    <a pitchFoot class="pitch__tour" routerLink="/walkthrough">
      <ion-icon name="play-circle-outline" aria-hidden="true"></ion-icon>
      <span>{{ 'app.pages.auth.login.pitch.tour' | translate }}</span>
    </a>

    <!-- The fields are dynamic-forms controls (kz2 rule: every form goes through dynamic-forms). -->
    <form class="form" [formGroup]="form" (ngSubmit)="onSubmit()">
      <div>
        <h1 class="form__title">{{ 'app.pages.auth.login.title' | translate }}</h1>
        <p class="form__lede">{{ 'app.pages.auth.login.lede' | translate }}</p>
      </div>

      <div class="form__fields">
        <kz-dynamic-form-control [model]="modelMap.get('username')" [group]="form"></kz-dynamic-form-control>
        <kz-dynamic-form-control [model]="modelMap.get('password')" [group]="form"></kz-dynamic-form-control>
        <div class="link-row">
          <button class="link" type="button" (click)="onForgotPassword()">
            {{ 'app.pages.auth.login.forgot' | translate }}
          </button>
        </div>
      </div>

      @if (loginFailed) {
        <app-kz-inline-alert
          class="form__notice"
          role="alert"
          tone="stop"
          icon="alert-circle-outline"
          [heading]="'app.pages.login.loginFailed' | translate"
        >
          {{ (accountSuspended ? 'app.pages.login.accountSuspended' : 'app.pages.login.usernameOrPasswordInvalid') | translate }}
        </app-kz-inline-alert>
      }
      <!-- Enter submits; the visible CTA lives in the dock. -->
      <button type="submit" hidden aria-hidden="true" tabindex="-1"></button>
    </form>

    <app-kz-inline-alert
      reassure
      tone="quiet"
      icon="cloud-offline-outline"
      [heading]="'app.pages.auth.login.reassure.title' | translate"
    >
      {{ 'app.pages.auth.login.reassure.body' | translate }}
    </app-kz-inline-alert>

    <button dock class="cta" type="button" (click)="onSubmit()" [disabled]="isLoadingState">
      <span>{{ 'app.pages.auth.login.cta' | translate }}</span>
      <ion-icon class="cta__icon" name="arrow-forward-outline" aria-hidden="true"></ion-icon>
    </button>
    <div dock class="docklinks">
      <a class="docklinks__tour" routerLink="/walkthrough">
        <ion-icon name="play-circle-outline" aria-hidden="true"></ion-icon>
        <span>{{ 'app.pages.auth.login.dock.tour' | translate }}</span>
      </a>
      <span class="docklinks__account">
        {{ 'app.pages.auth.login.noAccount' | translate }}
        <a routerLink="/signup">{{ 'app.pages.auth.login.register' | translate }}</a>
      </span>
    </div>
  </app-kz-auth-shell>
</ion-content>
